import React, { Component, ReactNode } from "react";

import * as Sentry from "@sentry/react";

type PropsType = {
  children: ReactNode;
  fallback?: ReactNode;
};

type StateType = {
  hasError: boolean;
};

export class EditorErrorBoundary extends Component<PropsType, StateType> {
  constructor(props: PropsType) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): StateType {
    // Draft.jsの既知の問題を回避するため、エラー状態にせずforceUpdateで対応
    // https://github.com/facebookarchive/draft-js/issues/1320#issuecomment-472776784
    return { hasError: false };
  }

  override componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    Sentry.captureException(error, {
      tags: {
        component: "Editor",
        errorBoundary: "EditorErrorBoundary",
      },
      contexts: {
        react: {
          componentStack: errorInfo.componentStack,
        },
      },
    });

    // Draft.jsの既知の問題を回避するためにforceUpdateを呼び出す
    // https://github.com/facebookarchive/draft-js/issues/1320#issuecomment-472776784
    this.forceUpdate();
  }

  override render(): ReactNode {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div className="rounded border border-red-300 bg-red-50 p-4 text-red-700">
            エディタでエラーが発生しました。ページを再読み込みしてください。
          </div>
        )
      );
    }

    return this.props.children;
  }
}
